/** Pure labels shared by the thing and bundle pocket levels. */
import type { FocusView, MemoryFact, ThingKind } from "@/api/memory-focus";
import {
  bundleLabel,
  capitalize,
  factScopeLine,
  thingDisplayName,
} from "@/lib/memory-thing-kinds";
import type { MemoryState } from "@/stores/memory-store";

/** A fact the focus view or the globe already holds. */
export function findFact(
  state: Pick<MemoryState, "globe" | "focusView">,
  id: string,
): MemoryFact | null {
  return (
    state.focusView?.ring
      .flatMap((slot) => slot.facts)
      .find((fact) => fact.id === id) ??
    state.globe?.facts.find((fact) => fact.id === id) ??
    null
  );
}

/** "38 more topics" when topics are already around the focus, otherwise "38 topics". */
export function bundleTitle(view: FocusView, kind: ThingKind): string {
  const count = view.bundles.find((bundle) => bundle.kind === kind)?.count ?? 0;
  return capitalize(
    bundleLabel(
      kind,
      count,
      view.ring.filter((slot) => slot.thing.kind === kind).length,
    ),
  );
}

/** The other end, plus where a limited fact applies: "Figma, applies when designing". */
export function factSecondLine(fact: MemoryFact, viewpointId: string): string {
  const other = fact.source.id === viewpointId ? fact.target : fact.source;
  const scope =
    fact.qualifiers.length > 0 ? factScopeLine(fact.qualifiers) : "";
  return [
    thingDisplayName(other),
    scope.charAt(0).toLowerCase() + scope.slice(1),
  ]
    .filter(Boolean)
    .join(", ");
}
